module.exports = __webpack_public_path__ + "media/images/ui-icons_555555_256x240-91ae2e7a5e6b6310998f1d691cd9a16f.png";